import { render } from "./AppImgWrapper.vue?vue&type=template&id=6d5a55dc&scoped=true&ts=true"
import script from "./AppImgWrapper.vue?vue&type=script&lang=ts"
export * from "./AppImgWrapper.vue?vue&type=script&lang=ts"

import "./AppImgWrapper.vue?vue&type=style&index=0&id=6d5a55dc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5a55dc"]])

export default __exports__